import './config';
import React from 'react';
import {Footer} from './Footer';
import axios from 'axios';
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { FacebookIcon, TwitterIcon } from "react-share";
import md5 from 'md5';
import styled from 'styled-components';
import Modal from './components/modal/modal';

export const FlexContainer100 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;

  & > div:nth-child(1) {
    flex: 10;

    & > img {
      width: 100%;
    }
  }

  @media (max-width: 960px){
    flex-direction: column;
  }
`;

export class SoleauDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: 'Loading...',
      textualContent: '',
      tx: '',
      tokenId: 0,
      blockNumber: 0,
      createdAt: '',
      textualMD5: '',
      imageMD5: '',
      fileName: '',
      owner: '',
      textualContentVerifyResult: '',
      modalOpen: false,
      modalContent: {},
      shareURL: '',
      isShareURLCopied: false,
      shareHTMLCode: '',
      isShareHTMLCodeCopied: false,
      isLoaded: false,
      isLoadingOnChainData: false,
      didVerifyOnChainPress: false,
      onChainDataLoadingStatus: 'Loading on-chain data......',
      onChainDataResult: ''
    };

    this.verifyTextualContentMd5 = this.verifyTextualContentMd5.bind(this);
    this.verifyOnChainData = this.verifyOnChainData.bind(this);
  }  

  componentDidMount()
  {
    const urlParams = new URLSearchParams(window.location.search);    

    let urlPath = window.location.href;
    let urlSegments = urlPath.split("/");
    let lastSegment = urlSegments[urlSegments.length - 1];
    console.log(lastSegment);

    let tokenId = 0;
    if(!Number.isNaN(lastSegment))
    {
     let id = Number(lastSegment);
      if(Number.isInteger(id))
        tokenId = id;      
    }

    if(tokenId > 0)
    {
      this.getSolueaDetail(tokenId).then((data)=>{

        console.log('data.length: ' + data.length);

        if(data.length > 0)
        {          
          let row = data[0];
          console.log(JSON.stringify(row));

          let content = JSON.parse(row['content']);
          
          let imageMD5 = '';
          if(content['imageHashSet'].length > 0)
            imageMD5 = content['imageHashSet'][0];          
          
          this.setState({
            title: row['title'],            
            textualContent: row['textualContent'],
            tx: row['tx'],
            tokenId: tokenId,
            blockNumber: row['blockNumber'],
            createdAt: new Date(row['createdAt']).toLocaleDateString('en-US'),
            textualMD5: content['textualMD5'],
            imageMD5: imageMD5,
            fileName: row['fileName'],
            owner: row['address'],
            shareURL: 'https://nft.deyey.com/' + tokenId,
            shareHTMLCode: '<a href="https://nft.deyey.com/' + tokenId + '" target="_blank"><img src="https://soleau.deyey.com/assets/images/share-widget.png" /></a>',
            isLoaded: true
          });          

        }
        else
        {
          window.location.replace(global.config.domainURL);
        }

      }).catch((e)=>{

        //console.log('failed to get soleau');
        //console.log(JSON.stringify(e));
        window.location.replace(global.config.domainURL);

      });
    }
    else
    {
      window.location.replace(global.config.domainURL);
    }
  }

  setModalOpen(isOpen) {
    this.setState({ modalOpen: isOpen });
  }

  setModalContent(item) {
    
    if(!Number.isInteger(item['blockNumber']))
      item['blockNumber'] = 0;

    this.setState({
      modalOpen: true,
      modalContent: item,
    });
    
  }

  verifyTextualContentMd5()
  {
    this.setState({textualContentVerifyResult: md5(this.state.textualContent)});
  }

  /*
  htmlEntities(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  */

  verifyOnChainData()
  {
    this.setState({isLoadingOnChainData: true, didVerifyOnChainPress: true});

    this.getOnChainSoleauDetail(this.state.tokenId, this.state.tx).then((data)=>{

      let status = '"content" attribute of a broadcasted event timestamped at block ' + this.state.blockNumber + ' from the contract ' + global.config.contractAddress + ' on Polygon Mainnet contains';
      this.setState({onChainDataResult: JSON.stringify(data), onChainDataLoadingStatus: status});

    });

  }

  getOnChainSoleauDetail(tokenId, hash)
  {
    return new Promise((resolve, reject)=>{

      var postData = {tokenId: tokenId, hash: hash};
      let axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
      };

      axios.post(global.config.lambdaGetSoleauOnChainDetail, postData, axiosConfig)
      .then((res) => {

        var data = res['data'];
          
          console.log(JSON.stringify(data));        
          resolve(data);            
        
      })
      .catch((err) => {
        console.log("AXIOS ERROR: " + JSON.stringify(err));

        /*
        if(Object.keys(err).length !== 0)
        {
        }
        */
        reject(err);

      });

    });    
  }

  getSolueaDetail(id)
  {
    return new Promise((resolve, reject)=>{

      var postData = {tokenId: id};
      let axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
      };

      axios.post(global.config.lambdaGetSoleauByTokenId, postData, axiosConfig)
      .then((res) => {

        var data = res['data'];
        //console.log(JSON.stringify(data));
        
        if(data)
        {
          if(data['result'] && data['items'])
          {
            //console.log('data :' + JSON.stringify(data['items']));
            resolve(data['items']);
          }
          else
          {
            resolve([]);
          }
        }
        else
        {
          resolve([]);
        }
        
      })
      .catch((err) => {
        console.log("AXIOS ERROR: " + JSON.stringify(err));

        /*
        if(Object.keys(err).length !== 0)
        {
        }
        */
        reject(err);

      });

    });
  }

  getOriginalImageURL(filename) {
    if (filename != '' && filename != undefined) {
      return global.config.imageS3BucketPath + filename;
    } else {
      return global.config.defaultSoleauListImage[Math.floor((Math.random() * global.config.defaultSoleauListImage.length) + 1)];
    }
  }

  render() {

      return (
  
  <React.Fragment>    

    <Modal
      open={this.state.modalOpen}
      onClose={
        () => {
          this.setModalContent({});
          this.setModalOpen(false);
        }
      }
    >
      <FlexContainer100>
        <div>
          {Object.keys(this.state.modalContent).length !== 0 && 
            <img
              src={this.getOriginalImageURL(this.state.modalContent['fileName'])}
              alt="image"
            />
          }
          {Object.keys(this.state.modalContent).length == 0 && 
            <img
              src={global.config.defaultSoleauListImage[0]}
              alt="image"
            />
          }             
        </div>
      </FlexContainer100>
    </Modal>

    {this.state.isLoaded &&
    <div>

    <div
      class="
        ud-header
        bg-transparent
        absolute
        top-0
        left-0
        z-40
        w-full
        flex
        items-center
      "
    >
      <div class="container">
        <div class="flex -mx-4 items-center justify-between relative">
          <div class="px-4 w-60 max-w-full">
            <a href={global.config.domainURL} class="navbar-logo w-full block py-5">
              <img
                src={global.config.domainURL + "assets/images/logo/logo-white.svg"}
                alt="logo"
                class="w-full header-logo"
              />
            </a>
          </div>
          <div class="flex px-4 justify-between items-center w-full">
            <div>
              <button
                id="navbarToggler"
                class="
                  block
                  absolute
                  right-4
                  top-1/2
                  -translate-y-1/2
                  lg:hidden
                  focus:ring-2
                  ring-primary
                  px-3
                  py-[6px]
                  rounded-lg
                "
              >
                <span
                  class="relative w-[30px] h-[2px] my-[6px] block bg-white"
                ></span>
                <span
                  class="relative w-[30px] h-[2px] my-[6px] block bg-white"
                ></span>
                <span
                  class="relative w-[30px] h-[2px] my-[6px] block bg-white"
                ></span>
              </button>

              {/*
              <nav
                id="navbarCollapse"
                className="
                  absolute
                  py-5
                  lg:py-0 lg:px-4
                  xl:px-6
                  bg-white
                  lg:bg-transparent
                  shadow-lg
                  rounded-lg
                  max-w-[250px]
                  w-full
                  lg:max-w-full lg:w-full
                  right-4
                  top-full
                  hidden
                  lg:block lg:static lg:shadow-none
                "
              >
                <ul className="blcok lg:flex">
                  <li className="relative group">
                    <a
                      href="#"
                      className="
                        ud-menu-scroll
                        text-base text-dark
                        lg:text-white
                        lg:group-hover:opacity-70
                        lg:group-hover:text-white
                        group-hover:text-primary
                        py-2
                        lg:py-6 lg:inline-flex lg:px-0
                        flex
                        mx-8
                        lg:mr-0
                      "                      
                    >
                      What's this
                    </a>
                  </li>
                </ul>
              </nav>
              */}

            </div>
            <div class="sm:flex justify-end hidden pr-16 lg:pr-0">
              <a
                href="https://medium.com/@delancer.online/how-soleau-live-works-e0a334895bbc"
                class="
                  text-base
                  font-medium
                  text-white
                  bg-white bg-opacity-20
                  rounded-lg
                  py-3
                  px-6
                  hover:bg-opacity-100 hover:text-dark
                  signUpBtn
                  duration-300
                  ease-in-out
                "
                target="_blank"
              >
                What's this?
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="
        relative
        z-10
        pt-[120px]
        md:pt-[130px]
        lg:pt-[160px]
        pb-[100px]
        bg-primary
        overflow-hidden
      "
    >
      <div class="container">
        <div class="flex flex-wrap items-center -mx-4">
          <div class="w-full px-4">
            <div class="text-center">
              <h1 class="font-semibold text-white text-4xl">{this.state.title}</h1>
            </div>
          </div>
        </div>
      </div>
      <div>
        <span class="absolute top-0 left-0 z-[-1]">
          <svg
            width="495"
            height="470"
            viewBox="0 0 495 470"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="55"
              cy="442"
              r="138"
              stroke="white"
              stroke-opacity="0.04"
              stroke-width="50"
            />
            <circle
              cx="446"
              r="39"
              stroke="white"
              stroke-opacity="0.04"
              stroke-width="20"
            />
            <path
              d="M245.406 137.609L233.985 94.9852L276.609 106.406L245.406 137.609Z"
              stroke="white"
              stroke-opacity="0.08"
              stroke-width="12"
            />
          </svg>
        </span>
        <span class="absolute top-0 right-0 z-[-1]">
          <svg
            width="493"
            height="470"
            viewBox="0 0 493 470"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="462"
              cy="5"
              r="138"
              stroke="white"
              stroke-opacity="0.04"
              stroke-width="50"
            />
            <circle
              cx="49"
              cy="470"
              r="39"
              stroke="white"
              stroke-opacity="0.04"
              stroke-width="20"
            />
            <path
              d="M222.393 226.701L272.808 213.192L259.299 263.607L222.393 226.701Z"
              stroke="white"
              stroke-opacity="0.06"
              stroke-width="13"
            />
          </svg>
        </span>
      </div>
    </div>

    <section class="pt-20 lg:pt-[120px] pb-10 lg:pb-20">
      <div class="container">
        <div class="flex flex-wrap justify-center -mx-4">
          <div class="w-full px-4">
            
            {this.state.fileName != '' &&
            <div
              class="
                relative
                rounded
                overflow-hidden
                z-20
                mb-[60px]
                h-[300px]
                md:h-[400px]
                lg:h-[500px]
                wow
                fadeInUp
              "
              data-wow-delay=".1s
              "
            >
              
              <img
                src={this.getOriginalImageURL(this.state.fileName)}
                alt="image"
                class="w-full h-full object-cover object-center"
              />

              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  console.log('click');
                  this.setModalContent(this.state);
                }}
              >              
              
              <div
                class="
                  absolute
                  w-full
                  h-full
                  top-0
                  left-0
                  flex
                  items-end
                  z-10
                  bg-gradient-to-t
                  from-dark-700
                  to-transparent
                "
              >
                <div class="flex flex-wrap items-center p-4 sm:p-8 pb-4">                  

                  {this.state.imageMD5 != '' &&
                  <div class="flex items-center mb-4">
                    <p
                      class="
                        flex
                        items-center
                        text-sm
                        font-medium
                        text-white
                        mr-5
                        md:mr-8
                      "
                    >
                      <span class="mr-3">
                        <img src={global.config.domainURL + "assets/images/hash-icon.svg"} width="18" height="18" />                        
                      </span>
                      {this.state.imageMD5}
                    </p>                    
                  </div>
                  }

                </div>
              </div>              

              </a>


            </div>
            }

            <div class="flex flex-wrap -mx-4">
              
              <div class="w-full lg:w-8/12 px-4">
                <div>
                  <h2
                    class="
                      font-bold
                      text-dark text-[26px]
                      sm:text-3xl
                      md:text-4xl
                      leading-snug
                      sm:leading-snug
                      md:leading-snug
                      mb-6
                      wow
                      fadeInUp
                    "
                    data-wow-delay=".1s
                    "
                  >
                    {this.state.title}
                  </h2>

                  <div class="flex flex-wrap items-center" style={{marginBottom: '1em'}}>
                    
                    <div class="flex items-center mb-4">
                      <p class=" flex items-center text-sm font-medium text-white mr-5 md:mr-8 ">
                        <span class="mr-3">
                          <svg width="16" height="16" viewBox="0 0 15 15" style={{fill: 'gray'}}>
                            <path d="M3.8958 8.67529H3.10715C2.96376 8.67529 2.86816 8.77089 2.86816 8.91428V9.67904C2.86816 9.82243 2.96376 9.91802 3.10715 9.91802H3.8958C4.03919 9.91802 4.13479 9.82243 4.13479 9.67904V8.91428C4.13479 8.77089 4.03919 8.67529 3.8958 8.67529Z"></path><path d="M6.429 8.67529H5.64035C5.49696 8.67529 5.40137 8.77089 5.40137 8.91428V9.67904C5.40137 9.82243 5.49696 9.91802 5.64035 9.91802H6.429C6.57239 9.91802 6.66799 9.82243 6.66799 9.67904V8.91428C6.66799 8.77089 6.5485 8.67529 6.429 8.67529Z"></path>
                            <path d="M8.93779 8.67529H8.14914C8.00575 8.67529 7.91016 8.77089 7.91016 8.91428V9.67904C7.91016 9.82243 8.00575 9.91802 8.14914 9.91802H8.93779C9.08118 9.91802 9.17678 9.82243 9.17678 9.67904V8.91428C9.17678 8.77089 9.08118 8.67529 8.93779 8.67529Z"></path><path d="M11.472 8.67529H10.6833C10.5399 8.67529 10.4443 8.77089 10.4443 8.91428V9.67904C10.4443 9.82243 10.5399 9.91802 10.6833 9.91802H11.472C11.6154 9.91802 11.711 9.82243 11.711 9.67904V8.91428C11.711 8.77089 11.5915 8.67529 11.472 8.67529Z"></path>
                            <path d="M3.8958 11.1606H3.10715C2.96376 11.1606 2.86816 11.2562 2.86816 11.3996V12.1644C2.86816 12.3078 2.96376 12.4034 3.10715 12.4034H3.8958C4.03919 12.4034 4.13479 12.3078 4.13479 12.1644V11.3996C4.13479 11.2562 4.03919 11.1606 3.8958 11.1606Z"></path><path d="M6.429 11.1606H5.64035C5.49696 11.1606 5.40137 11.2562 5.40137 11.3996V12.1644C5.40137 12.3078 5.49696 12.4034 5.64035 12.4034H6.429C6.57239 12.4034 6.66799 12.3078 6.66799 12.1644V11.3996C6.66799 11.2562 6.5485 11.1606 6.429 11.1606Z"></path>
                            <path d="M8.93779 11.1606H8.14914C8.00575 11.1606 7.91016 11.2562 7.91016 11.3996V12.1644C7.91016 12.3078 8.00575 12.4034 8.14914 12.4034H8.93779C9.08118 12.4034 9.17678 12.3078 9.17678 12.1644V11.3996C9.17678 11.2562 9.08118 11.1606 8.93779 11.1606Z"></path><path d="M11.472 11.1606H10.6833C10.5399 11.1606 10.4443 11.2562 10.4443 11.3996V12.1644C10.4443 12.3078 10.5399 12.4034 10.6833 12.4034H11.472C11.6154 12.4034 11.711 12.3078 11.711 12.1644V11.3996C11.711 11.2562 11.5915 11.1606 11.472 11.1606Z"></path>
                            <path d="M13.2637 3.3697H7.64754V2.58105C8.19721 2.43765 8.62738 1.91189 8.62738 1.31442C8.62738 0.597464 8.02992 0 7.28906 0C6.54821 0 5.95074 0.597464 5.95074 1.31442C5.95074 1.91189 6.35702 2.41376 6.93058 2.58105V3.3697H1.31442C0.597464 3.3697 0 3.96716 0 4.68412V13.2637C0 13.9807 0.597464 14.5781 1.31442 14.5781H13.2637C13.9807 14.5781 14.5781 13.9807 14.5781 13.2637V4.68412C14.5781 3.96716 13.9807 3.3697 13.2637 3.3697ZM6.6677 1.31442C6.6677 0.979841 6.93058 0.716957 7.28906 0.716957C7.62364 0.716957 7.91042 0.979841 7.91042 1.31442C7.91042 1.649 7.64754 1.91189 7.28906 1.91189C6.95448 1.91189 6.6677 1.6251 6.6677 1.31442ZM1.31442 4.08665H13.2637C13.5983 4.08665 13.8612 4.34954 13.8612 4.68412V6.45261H0.716957V4.68412C0.716957 4.34954 0.979841 4.08665 1.31442 4.08665ZM13.2637 13.8612H1.31442C0.979841 13.8612 0.716957 13.5983 0.716957 13.2637V7.16957H13.8612V13.2637C13.8612 13.5983 13.5983 13.8612 13.2637 13.8612Z"></path>
                          </svg>
                        </span>
                        <span style={{color: 'gray'}}>{this.state.createdAt}</span>
                      </p>
                    </div>
                    
                    {this.state.blockNumber > 0 &&
                    <div class="flex items-center mb-4">
                      <p class=" flex items-center text-sm font-medium text-white mr-5 md:mr-8 ">
                        <span class="mr-3">
                          <img src={global.config.domainURL + "assets/images/book-icon-gray.svg"} width="18" height="18" alt="Block number" />
                        </span>
                        <a href={global.config.blockExplorerPath + this.state.tx} class="hover:opacity-70" style={{color: 'gray'}} target="_blank">{this.state.blockNumber}</a>
                      </p>
                    </div>
                    }

                    {this.state.fileName != '' &&
                    <div class="flex items-center mb-4">
                      <p class=" flex items-center text-sm font-medium text-white mr-5 md:mr-8 ">
                        <span class="mr-3">
                          <svg width="16" height="16" viewBox="0 0 330 330" style={{fill: 'gray'}}>
                            <path id="XMLID_24_" d="M154.389,255.602c0.351,0.351,0.719,0.683,1.103,0.998c0.169,0.138,0.347,0.258,0.52,0.388
                              c0.218,0.164,0.432,0.333,0.659,0.484c0.212,0.142,0.432,0.265,0.649,0.395c0.202,0.121,0.4,0.248,0.608,0.359
                              c0.223,0.12,0.453,0.221,0.681,0.328c0.215,0.102,0.427,0.21,0.648,0.301c0.223,0.092,0.45,0.167,0.676,0.247
                              c0.236,0.085,0.468,0.175,0.709,0.248c0.226,0.068,0.456,0.119,0.684,0.176c0.246,0.062,0.489,0.131,0.739,0.181
                              c0.263,0.052,0.529,0.083,0.794,0.121c0.219,0.031,0.435,0.073,0.658,0.095c0.492,0.048,0.986,0.075,1.48,0.075
                              c0.494,0,0.988-0.026,1.479-0.075c0.226-0.022,0.444-0.064,0.667-0.096c0.262-0.037,0.524-0.068,0.784-0.12
                              c0.255-0.05,0.504-0.121,0.754-0.184c0.223-0.057,0.448-0.105,0.669-0.172c0.246-0.075,0.483-0.167,0.724-0.253
                              c0.221-0.08,0.444-0.152,0.662-0.242c0.225-0.093,0.44-0.202,0.659-0.306c0.225-0.106,0.452-0.206,0.672-0.324
                              c0.21-0.112,0.408-0.239,0.611-0.361c0.217-0.13,0.437-0.252,0.648-0.394c0.222-0.148,0.431-0.314,0.644-0.473
                              c0.179-0.134,0.362-0.258,0.536-0.4c0.365-0.3,0.714-0.617,1.049-0.949c0.016-0.016,0.034-0.028,0.049-0.044l70.002-69.998
                              c5.858-5.858,5.858-15.355,0-21.213c-5.857-5.857-15.355-5.858-21.213-0.001l-44.396,44.393V25c0-8.284-6.716-15-15-15
                              c-8.284,0-15,6.716-15,15v183.785l-44.392-44.391c-5.857-5.858-15.355-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213
                              L154.389,255.602z"/>
                            <path id="XMLID_25_" d="M315,160c-8.284,0-15,6.716-15,15v115H30V175c0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15v130
                              c0,8.284,6.716,15,15,15h300c8.284,0,15-6.716,15-15V175C330,166.716,323.284,160,315,160z"/>                          
                          </svg>
                        </span>
                        <span style={{color: 'gray'}}><a href={this.getOriginalImageURL(this.state['fileName'])}>Download Image</a></span>
                      </p>
                    </div>
                    }

                  </div>

                  {
                  <div
                    class="
                      bg-primary bg-opacity-5
                      rounded
                      overflow-hidden
                      relative
                      py-8
                      px-6
                      sm:p-10
                      md:px-[60px]
                      text-center
                      z-10
                      mb-10
                      wow
                      fadeInUp
                    "
                    data-wow-delay=".1s
                    "
                  >
                    <div class="max-w-[530px] mx-auto">
                      <span class="flex justify-center mb-6 text-primary">
                        <svg
                          width="44"
                          height="26"
                          viewBox="0 0 44 26"
                          class="fill-current"
                        >
                          <path
                            d="M10.1101 0.00124908C5.46698 -0.0701833 1.25247 2.92998 0.252417 7.00162C-0.319041 9.50175 0.180985 12.0019 1.68106 14.002C3.25258 16.145 5.68128 17.5022 8.39571 17.8593L10.8958 24.0025C11.1816 24.6454 11.8245 25.074 12.5388 25.074C13.2531 25.074 13.896 24.6454 14.1817 24.0025C14.6103 22.931 15.1103 21.7881 15.6104 20.7166C16.8247 18.0022 18.0391 15.2163 18.9677 12.359C19.9677 9.35889 19.5392 6.14443 17.8248 3.71573C16.1104 1.35846 13.396 0.0726814 10.1101 0.00124908ZM16.6104 11.6447C15.6818 14.3592 14.4675 17.145 13.3245 19.788C13.1102 20.3595 12.8245 20.8595 12.6102 21.431L10.1815 15.5735L9.39576 15.5021C7.10992 15.3592 4.96695 14.2163 3.7526 12.5733C2.68112 11.1447 2.32396 9.35889 2.75255 7.64451C3.46687 4.71579 6.53846 2.57281 10.0386 2.57281H10.1101C12.5388 2.57281 14.5389 3.57287 15.8247 5.28724C17.039 7.00162 17.3247 9.43032 16.6104 11.6447Z"
                          />
                          <path
                            d="M42.3267 3.78726C40.6124 1.35856 37.8979 0.00134277 34.612 0.00134277C34.5406 0.00134277 34.5406 0.00134277 34.4692 0.00134277C29.8975 0.00134277 25.7544 3.0015 24.7544 7.00171C24.1829 9.50185 24.6829 12.002 26.183 14.0735C27.7545 16.2165 30.1832 17.5737 32.8977 17.9309L35.3978 24.074C35.6835 24.7169 36.3264 25.1455 37.0407 25.1455C37.7551 25.1455 38.398 24.7169 38.6837 24.074C39.1123 23.0026 39.6123 21.8596 40.1123 20.7882C41.3267 18.0737 42.541 15.2879 43.4696 12.4306C44.4697 9.50184 44.0411 6.21596 42.3267 3.78726ZM41.1124 11.6448C40.1838 14.3592 38.9694 17.1451 37.8265 19.7881C37.6122 20.3596 37.3265 20.8596 37.1122 21.431L34.6835 15.5736L33.8977 15.5022C31.6119 15.3593 29.4689 14.2164 28.2546 12.5734C27.1831 11.1448 26.8259 9.35898 27.2545 7.57317C27.9688 4.64445 31.0404 2.50147 34.5406 2.50147H34.612C37.0407 2.50147 39.0408 3.50153 40.3266 5.2159C41.541 7.00171 41.8267 9.43041 41.1124 11.6448Z"
                          />
                        </svg>
                      </span>
                      
                      <div
                        class="
                          font-medium
                          text-dark text-base
                          italic
                          leading-[26px]
                          mb-4
                        "
                      >
                        <p style={{fontStyle: 'normal'}}>MD5 of this textual content</p> 
                        <p style={{fontWeight: '300'}}>{this.state.textualMD5}</p>
                      </div>

                      {(!this.state.didVerifyOnChainPress && this.state.blockNumber > 0) &&
                      <div
                        class="
                          font-medium
                          text-dark text-base
                          italic
                          leading-[26px]
                          mb-4
                        "
                      >
                        <input
                          type="button"
                          value="Verify On-chain Data"
                          class="
                            text-center
                            h-[50px]
                            text-white
                            rounded
                            mb-6
                            bg-[#13C296]
                            cursor-pointer
                            hover:shadow-lg hover:bg-opacity-90
                            transition
                            duration-300
                            ease-in-out
                          "
                          style={{paddingLeft: '1rem', paddingRight: '1rem'}}
                          onClick={this.verifyOnChainData}
                        />
                      </div>
                      }

                      {this.state.isLoadingOnChainData &&
                      <div
                        class="
                          font-medium
                          text-dark text-base
                          italic
                          leading-[26px]
                          mb-4
                        "
                      >
                        <p style={{fontWeight: '200', fontStyle: 'normal'}}>{this.state.onChainDataLoadingStatus}</p> 
                      </div>
                      }

                      {this.state.onChainDataResult != '' &&
                      <div
                        class="
                          font-medium
                          text-dark text-base
                          italic
                          leading-[26px]
                          mb-4
                        "
                      >
                        <textarea
                          class="
                            w-full
                            h-[50px]
                            text-sm
                            bg-white bg-opacity-20
                            placeholder-white
                            rounded
                            mb-4
                            outline-none
                            border border-transparent
                            focus-visible:shadow-none
                            focus:border-white
                          "
                          style={{height: '6rem', padding: '6px'}}
                          value={this.state.onChainDataResult}
                          readOnly
                        >                    
                        </textarea>
                        <p style={{fontWeight: '200', fontStyle: 'normal'}}>You can check with the MD5 hash specified in 'textualMD5' attritube. It should be <span style={{fontStyle: 'italic', fontWeight: '300'}}>{this.state.textualMD5}</span>.</p>
                      </div>
                      }

                    </div>

                    <div>
                      <span class="absolute left-0 top-0">
                        <svg
                          width="103"
                          height="109"
                          viewBox="0 0 103 109"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse
                            cx="0.483916"
                            cy="3.5"
                            rx="102.075"
                            ry="105.5"
                            transform="rotate(180 0.483916 3.5)"
                            fill="url(#paint0_linear)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear"
                              x1="-101.591"
                              y1="-50.4346"
                              x2="49.1618"
                              y2="-49.6518"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#3056D3" stop-opacity="0.15" />
                              <stop
                                offset="1"
                                stop-color="white"
                                stop-opacity="0"
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                      <span class="absolute bottom-0 right-0">
                        <svg
                          width="102"
                          height="106"
                          viewBox="0 0 102 106"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse
                            cx="102.484"
                            cy="105.5"
                            rx="102.075"
                            ry="105.5"
                            fill="url(#paint0_linear)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear"
                              x1="0.409163"
                              y1="51.5654"
                              x2="151.162"
                              y2="52.3482"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#3056D3" stop-opacity="0.5" />
                              <stop
                                offset="1"
                                stop-color="white"
                                stop-opacity=".2"
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                    </div>
                  </div>
                  }

                  <p
                    class="
                      text-base text-body-color
                      leading-relaxed
                      mb-8
                      wow
                      fadeInUp
                    "
                    data-wow-delay=".1s"
                    style={{whiteSpace: 'pre-line', marginBottom: '2rem'}}
                  >
                    {this.state.textualContent}
                  </p>                  
                  
                  <div class="font-semibold text-white text-4xl" style={{fontWeight: '300', fontSize: 'small', fontStyle: 'italic', color: 'gray', marginBottom: '4rem'}}>owned by {this.state.owner}</div>

                  <div class="flex flex-wrap items-center -mx-4 mb-12">
                    <div class="w-full md:w-2/2 px-4">
                      <div
                        class="flex items-center md:justify-end wow fadeInUp"
                        data-wow-delay=".1s"
                      >
                        <span class="text-sm text-body-color font-medium mr-5">
                          Share This Envelope
                        </span>
                        <div class="flex items-center">

                          <div class="mr-4 mb-2">
                          <FacebookShareButton
                            url={global.config.domainURL + 'envelope/' + this.state.tokenId}
                            quote={"Here is My Creation in a Soleau Envelope"}
                            hashtag={"#soleauenvelope"}
                            description={"I have put my intelligent property into a Soleau Envelope."}
                          >
                            <FacebookIcon size={32} round />
                          </FacebookShareButton>
                          </div>

                          <div class="mr-4 mb-2">
                            <TwitterShareButton
                              title={"Here is My Creation in a Soleau Envelope"}
                              url={global.config.domainURL + 'envelope/' + this.state.tokenId}
                              hashtags={["soleauenvelope"]}
                            >
                              <TwitterIcon size={32} round />
                            </TwitterShareButton>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="w-full lg:w-4/12 px-4">
                <div>
                  
                  <div
                    class="
                      mb-12
                      bg-primary
                      rounded
                      relative
                      overflow-hidden
                      text-center
                      py-[60px]
                      px-11
                      lg:px-8
                      wow
                      fadeInUp
                    "
                    data-wow-delay=".1s
                    "
                  >

                    <h3 class="font-semibold text-white mb-2 text-2xl">
                      Link for Sharing
                    </h3>

                    <input
                      type="text"
                      class="
                        w-full
                        font-medium
                        bg-white bg-opacity-20
                        placeholder-white
                        text-white
                        rounded
                        mb-4
                        border border-transparent
                        focus-visible:shadow-none
                        focus:border-white
                      "
                      style={{padding: '6px'}}
                      value={this.state.shareURL}
                      readOnly
                    />

                    <input
                      type="button"
                      value="Copy"
                      class="
                        w-full
                        text-center
                        h-[50px]
                        text-white
                        rounded
                        mb-6
                        bg-[#13C296]
                        cursor-pointer
                        hover:shadow-lg hover:bg-opacity-90
                        transition
                        duration-300
                        ease-in-out
                      "
                      onClick={() => {this.setState({isShareURLCopied: true});navigator.clipboard.writeText(this.state.shareURL);}}
                    />

                    {this.state.isShareURLCopied &&
                      <div class="w-full mb-4 text-center" style={{color: 'white', fontStyle: 'italic', fontWeight: '300'}}>Copied to clipboard</div>
                    }

                    <hr class="w-full mb-6" />

                    <h3 class="font-semibold text-white mb-2 text-2xl">
                      HTML Widget Code
                    </h3>

                    <textarea
                      class="
                        w-full
                        h-[50px]
                        text-sm
                        font-medium
                        bg-white bg-opacity-20
                        placeholder-white
                        text-white
                        rounded
                        mb-4
                        outline-none
                        border border-transparent
                        focus-visible:shadow-none
                        focus:border-white
                      "
                      style={{height: '6rem', padding: '6px'}}
                      value={this.state.shareHTMLCode}
                      readOnly
                    >                    
                    </textarea>

                    <img 
                      src="https://soleau.deyey.com/assets/images/share-widget.png"
                      class="w-full mb-4"
                    />

                    <input
                      type="button"
                      value="Copy"
                      class="
                        w-full
                        text-center
                        h-[50px]
                        text-sm
                        font-medium
                        text-white
                        rounded
                        mb-6
                        bg-[#13C296]
                        cursor-pointer
                        hover:shadow-lg hover:bg-opacity-90
                        transition
                        duration-300
                        ease-in-out
                      "
                      onClick={() => {this.setState({isShareHTMLCodeCopied: true});navigator.clipboard.writeText(this.state.shareHTMLCode);}}
                    />

                    {this.state.isShareHTMLCodeCopied &&
                      <div class="w-full mb-4 text-center" style={{color: 'white', fontStyle: 'italic', fontWeight: '300'}}>Copied to clipboard</div>
                    }

                    <hr class="w-full mb-6" />

                    <h3 class="font-semibold text-white mb-2 text-2xl">
                      MD5 Verification
                    </h3>
                    <p class="text-base text-white mb-8">
                      {this.state.textualMD5}
                    </p>
                      <textarea
                        class="
                          w-full
                          h-[50px]
                          text-sm
                          font-medium
                          bg-white bg-opacity-20
                          placeholder-white
                          text-white
                          rounded
                          mb-4
                          outline-none
                          border border-transparent
                          focus-visible:shadow-none
                          focus:border-white
                        "
                        style={{height: '20rem', padding: '6px'}}
                        value={this.state.textualContent}
                        readOnly
                      >
                      </textarea>
                      <input
                        type="button"
                        value="Verify"
                        class="
                          w-full
                          text-center
                          h-[50px]
                          text-sm
                          font-medium
                          text-white
                          rounded
                          mb-6
                          bg-[#13C296]
                          cursor-pointer
                          hover:shadow-lg hover:bg-opacity-90
                          transition
                          duration-300
                          ease-in-out
                        "
                        onClick={this.verifyTextualContentMd5}
                      />
                    <p class="text-base text-white mb-8">
                      {this.state.textualContentVerifyResult}
                    </p>

                    <div>
                      <span class="absolute top-0 right-0">
                        <svg
                          width="46"
                          height="46"
                          viewBox="0 0 46 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="1.39737"
                            cy="44.6026"
                            r="1.39737"
                            transform="rotate(-90 1.39737 44.6026)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="1.39737"
                            cy="7.9913"
                            r="1.39737"
                            transform="rotate(-90 1.39737 7.9913)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="13.6943"
                            cy="44.6026"
                            r="1.39737"
                            transform="rotate(-90 13.6943 44.6026)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="13.6943"
                            cy="7.9913"
                            r="1.39737"
                            transform="rotate(-90 13.6943 7.9913)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="25.9911"
                            cy="44.6026"
                            r="1.39737"
                            transform="rotate(-90 25.9911 44.6026)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="25.9911"
                            cy="7.9913"
                            r="1.39737"
                            transform="rotate(-90 25.9911 7.9913)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="38.288"
                            cy="44.6026"
                            r="1.39737"
                            transform="rotate(-90 38.288 44.6026)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="38.288"
                            cy="7.9913"
                            r="1.39737"
                            transform="rotate(-90 38.288 7.9913)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="1.39737"
                            cy="32.3058"
                            r="1.39737"
                            transform="rotate(-90 1.39737 32.3058)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="13.6943"
                            cy="32.3058"
                            r="1.39737"
                            transform="rotate(-90 13.6943 32.3058)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="25.9911"
                            cy="32.3058"
                            r="1.39737"
                            transform="rotate(-90 25.9911 32.3058)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="38.288"
                            cy="32.3058"
                            r="1.39737"
                            transform="rotate(-90 38.288 32.3058)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="1.39737"
                            cy="20.0086"
                            r="1.39737"
                            transform="rotate(-90 1.39737 20.0086)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="13.6943"
                            cy="20.0086"
                            r="1.39737"
                            transform="rotate(-90 13.6943 20.0086)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="25.9911"
                            cy="20.0086"
                            r="1.39737"
                            transform="rotate(-90 25.9911 20.0086)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="38.288"
                            cy="20.0086"
                            r="1.39737"
                            transform="rotate(-90 38.288 20.0086)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                        </svg>
                      </span>
                      <span class="absolute bottom-0 left-0">
                        <svg
                          width="46"
                          height="46"
                          viewBox="0 0 46 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="1.39737"
                            cy="44.6026"
                            r="1.39737"
                            transform="rotate(-90 1.39737 44.6026)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="1.39737"
                            cy="7.9913"
                            r="1.39737"
                            transform="rotate(-90 1.39737 7.9913)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="13.6943"
                            cy="44.6026"
                            r="1.39737"
                            transform="rotate(-90 13.6943 44.6026)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="13.6943"
                            cy="7.9913"
                            r="1.39737"
                            transform="rotate(-90 13.6943 7.9913)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="25.9911"
                            cy="44.6026"
                            r="1.39737"
                            transform="rotate(-90 25.9911 44.6026)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="25.9911"
                            cy="7.9913"
                            r="1.39737"
                            transform="rotate(-90 25.9911 7.9913)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="38.288"
                            cy="44.6026"
                            r="1.39737"
                            transform="rotate(-90 38.288 44.6026)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="38.288"
                            cy="7.9913"
                            r="1.39737"
                            transform="rotate(-90 38.288 7.9913)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="1.39737"
                            cy="32.3058"
                            r="1.39737"
                            transform="rotate(-90 1.39737 32.3058)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="13.6943"
                            cy="32.3058"
                            r="1.39737"
                            transform="rotate(-90 13.6943 32.3058)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="25.9911"
                            cy="32.3058"
                            r="1.39737"
                            transform="rotate(-90 25.9911 32.3058)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="38.288"
                            cy="32.3058"
                            r="1.39737"
                            transform="rotate(-90 38.288 32.3058)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="1.39737"
                            cy="20.0086"
                            r="1.39737"
                            transform="rotate(-90 1.39737 20.0086)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="13.6943"
                            cy="20.0086"
                            r="1.39737"
                            transform="rotate(-90 13.6943 20.0086)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="25.9911"
                            cy="20.0086"
                            r="1.39737"
                            transform="rotate(-90 25.9911 20.0086)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <circle
                            cx="38.288"
                            cy="20.0086"
                            r="1.39737"
                            transform="rotate(-90 38.288 20.0086)"
                            fill="white"
                            fill-opacity="0.44"
                          />
                        </svg>
                      </span>
                    </div>

                  </div>                  

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </section>

    <Footer />

    </div>
    }

  </React.Fragment>
  
      );    
  }
}
export default SoleauDetail;